import { Avatar, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import user1Src from "./user1.jpg";

export default () => (
	<CssColumnGrid columns={2}>
		<Text semiBold text="image" />
		<Text semiBold text="no image" />
		<Avatar src={user1Src} />
		<Avatar initials="CS" />
	</CssColumnGrid>
);